/* eslint-disable sonar/for-in */
/* eslint-disable no-console */
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore commonsjs module
import { ApolloLink } from '@apollo/client';
export var removeTypenameFromVariables = function (variables) {
    if (typeof variables !== 'object' || variables === null) {
        return variables;
    }
    if (Array.isArray(variables)) {
        return variables.map(function (item) { return removeTypenameFromVariables(item); });
    }
    var newVariables = {};
    for (var key in variables) {
        if (key === '__typename') {
            continue;
        }
        newVariables[key] = removeTypenameFromVariables(variables[key]);
    }
    return newVariables;
};
export var removeTypenameLink = new ApolloLink(function (operation, forward) {
    if (operation.variables) {
        operation.variables = removeTypenameFromVariables(operation.variables);
    }
    return forward(operation);
});
//# sourceMappingURL=removeTypenameLink.js.map